const getSelectionCoords = () => {
  if (document.selection) {
    if (document.selection.type != 'Control') {
      const range = document.selection.createRange()

      if (range) {
        range.collapse(true)

        return {
          x: range.boundingLeft,
          y: range.boundingTop
        }
      }
    }
  } else if (window.getSelection) {
    const selection = window.getSelection()

    if (selection.rangeCount) {
      const range = selection.getRangeAt(0).cloneRange()

      if (range && range.getClientRects) {
        range.collapse(true)

        if (range.getClientRects().length > 0) {
          const rect = range.getClientRects()[0]

          return {
            x: rect.left,
            y: rect.top
          }
        }
      }

      try {
        const span = document.createElement('span')

        if (span.getClientRects) {
          span.appendChild(document.createTextNode('\u200B'))
          range.insertNode(span)

          const spanParent = span.parentNode
          const rect = span.getClientRects()[0]
          const x = rect.left
          const y = rect.top

          spanParent.removeChild(span)
          spanParent.normalize()

          return { x, y }
        }
      } catch {
        return {
          x: 0,
          y: 0
        }
      }
    }
  }

  return {
    x: 0,
    y: 0
  }
}

export default getSelectionCoords
